import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EmpBasicData, useEmployee } from '~/data/employee';
import { Enum, useAllEnums } from '~/data/enums';
import { CountryOption } from '~/types';

export type useEmployeeDataOutput = {
  empData: EmpBasicData;
  countryList: CountryOption[] | undefined;
  employeeStatusList: Enum[];
  genderOptions: {
    value: string;
    label: string;
  }[];
  isLoading: boolean;
  failedToLoad: boolean;
};

export const useEmployeeFormData = (): useEmployeeDataOutput => {
  const { t } = useTranslation();
  const { employee, isLoading, failedToLoad } = useEmployee();
  const {
    allEnums: { COUNTRY, EMPLOYEE_STATUS },
    isLoading: isLoadingEnums,
    failedToLoad: failedToLoadEnums,
  } = useAllEnums();
  const [empData, setEmpData] = useState<EmpBasicData>(employee.empBasicData);

  useEffect(() => {
    if (!isLoading && !failedToLoad) {
      setEmpData(employee.empBasicData);
    }
  }, [employee.empBasicData, failedToLoad, isLoading]);

  const genderOptions = [
    {
      value: 'M',
      label: t('laMale'),
    },
    {
      value: 'F',
      label: t('laFemale'),
    },
    {
      value: 'O',
      label: t('laOther'),
    },
  ];

  const countryList:
    | { countryName: string; countryCode: string }[]
    | undefined = COUNTRY?.map(({ code, name }) => {
    return { countryName: name, countryCode: code };
  });

  return {
    isLoading: isLoading || isLoadingEnums,
    countryList,
    employeeStatusList: EMPLOYEE_STATUS,
    genderOptions,
    empData,
    failedToLoad: failedToLoad || failedToLoadEnums,
  };
};
